import collect from 'collect.js';
import { formatPrice } from '@SHARED/js/helpers/misc';
import CdnMixin from '@SHARED/js/Vue/mixins/CdnMixin';
import Swal from 'sweetalert2';
import template from './CartComponent.html';
import InputNumber from '../InputNumber/InputNumberComponent';
import store from '../../store/store';
import ProductCartItem from '../../store/ProductCartItem';

export default {
  template,

  components: {
    InputNumber,
  },

  mixins: [CdnMixin],

  data() {
    return {
      sharedState: store,
    };
  },

  computed: {
    totalPrice() {
      return collect(store.cart.items).sum(item => item.getPrice() * item.quantity);
    },
  },

  created() {
    // Check async if data in cart is up-to-date
    store.refreshCartItems()
      .then((invalidItems) => {
        if (invalidItems.length) {
          Swal.fire(
            'OBS!',
            'Én eller flere produkter i handlevogenen krever at du er logget inn med rett brukerkonto. ' +
            'Klikk på "Gå til kassen" for å logge inn, eller fjern produktet fra handlekurven.',
            'warning',
          );
        }

        this.submitDataLayerCheckoutStep1Object();
      });
  },

  methods: {
    removeItem(index) {
      store.removeFromCart(index);
    },

    formatPrice,

    itemHasValidAuth(item) {
      if (typeof item.authUserHash !== 'undefined') {
        if (item.authUserHash === false) {
          return false;
        } else if (item.authUserHash === null) {
          return true;
        } else if (item.authUserHash === window.authUserHash) {
          return true;
        }

        return false;
      }

      return true;
    },

    submitDataLayerCheckoutStep1Object() {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'checkout',
        ecommerce: {
          checkout: {
            actionField: { step: 1 },
            products: collect(this.sharedState.cart.items).map(
              product => (new ProductCartItem(product)).getDataLayerObject(),
            ),
          },
        },
      });
    },
  },
};
